module.exports = __webpack_public_path__ + "img/cj.7e0bad37.png";